import LOADING_STATES from '@/constants/loading-states.js';
import { ERROR_STATES } from '@/voc/constants/constants';

export const EXPLORE_LOADING_STATES = Object.freeze({
    ...LOADING_STATES,
    ...ERROR_STATES,
    PROMPT_REPORT_LOADING: 'prompt_report_loading',
    SAVING: 'saving',
});

export const ITEM_TYPES = Object.freeze({
    feedback: {
        label: 'Feedback',
        icon: { type: 'message-square', color: 'var(--palette-gray-0)', backgroundColor: 'var(--palette-blue-70)' },
    },
    highlight: {
        label: 'Highlight',
        icon: 'ai/ai-highlight-icon.svg',
    },
    idea: {
        label: 'Idea',
        icon: { type: 'idea', color: 'var(--palette-gray-0)', backgroundColor: 'var(--palette-purple-80)' },
    },
    ideapoll: {
        label: 'Idea test',
        icon: { type: 'idea', color: 'var(--palette-gray-0)', backgroundColor: 'var(--palette-purple-80)' },
    },
    portal: {
        label: 'Portal',
        icon: { type: 'thumbs-up', color: 'var(--palette-gray-0)', backgroundColor: 'var(--palette-green-70)' },
    },
    proxy: {
        label: 'Proxy vote',
        icon: { type: 'idea', color: 'var(--palette-gray-0)', backgroundColor: 'var(--palette-purple-80)' },
    },
    topic: {
        label: 'Topic',
        icon: 'ai/ai-topic-icon.svg',
    },
});

export const INSIGHT_GROUP_SOURCE_TYPES = Object.freeze({
    HUMAN: 'human',
    AI: 'aiTagging',
    VOC_ITEM: 'vocItemSource',
    AUTOMATION_RULE: 'automationRule',
});

export const CACHE_TIME = 300000;
